/** 皮肤色值配置  */
export const SKIN_COLORS_CONFIG = {
  // 主题色
  themeColor: {
    opacity: 1,
    key: '--act-theme-color'
  },
  // 选中item背景
  itemBgActiveColor: {
    opacity: 0.06,
    key: '--act-item-bg-active-color'
  },
  // 标签未选中
  itemTagBgColor: {
    opacity: 0.16,
    key: '--act-item-tag-bg-color'
  },
  // 胶囊导航描边
  buttonBorderColor: {
    opacity: 0.65,
    key: '--act-nav-btn-border-color'
  },
  // 按钮按下的颜色
  buttonActiveColor: {
    opacity: 0.9,
    key: '--act-button-primary-active-color',
    blendColor: '#000000'
  }
}
